import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const StatContainer = styled.div`
    ${BaseStyle.Mixins.gaps.extraSmall}
    display: flex;
    flex: 1;
    flex-direction: column;
    place-content: center;
`;

export const StatValue = styled.div<{ $isTeam?: boolean }>`
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle1}
    color: ${({ theme }) => theme.Text.primary};
    height: 22px;
    text-align: center;

    ${BaseStyle.Mixins.screenSizes.medium} {
        height: 26px;
        ${({ $isTeam }) =>
            $isTeam ? BaseStyle.Mixins.fontStyles.ui['22b'] : BaseStyle.Mixins.fontStyles.desktop.subtitle1}
    }
`;

export const StatHeader = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
    color: ${({ theme }) => theme.Text.secondary};
    height: 12px;
    text-align: center;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['14m']}
        height: 14px;
    }
`;
